'use client';

// Error components must be Client Components
import { Button } from '@/components/ui/button';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
import { useEffect } from 'react';
export default function DefaultErrorPage({
  error,
  reset
}: {
  error: Error & {
    digest?: string;
  };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);
  return <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4" data-sentry-component="DefaultErrorPage" data-sentry-source-file="error.tsx">
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="text-center" data-sentry-element="unknown" data-sentry-source-file="error.tsx">
        <AlertCircle className="w-16 h-16 text-destructive mx-auto mb-6" data-sentry-element="AlertCircle" data-sentry-source-file="error.tsx" />
        <h1 className="text-4xl font-bold mb-2">Oops! Something went wrong</h1>
        <p className="text-muted-foreground mb-6">
          We're sorry, but it seems there was an error. Please try again.
        </p>
        <Button variant="default" size="lg" onClick={() => reset()} className="font-semibold" data-sentry-element="Button" data-sentry-source-file="error.tsx">
          Try Again
        </Button>
      </motion.div>
      <motion.p initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.5,
      duration: 0.5
    }} className="mt-8 text-sm text-muted-foreground" data-sentry-element="unknown" data-sentry-source-file="error.tsx">
        If the problem persists, please contact support.
      </motion.p>
    </div>;
}